import React, {useState, useEffect} from 'react';
import axios from 'axios';
import BodyCard from './BodyCard'
import { Link } from 'react-router-dom';

function Content() {
  const [post, setPosts] = useState([])
  const [placeCount, setPlaceCount] = useState()

  useEffect(() => {
    axios.get('/api/places')
      .then(res => {
        const placeCount = res.data.places.length
        setPlaceCount(placeCount)

        let prevAreaId = 0;
        const places = res.data.places;
        // 同じエリアの2つ目以降のplaceかどうかを確認
        for (let i = 0; i < placeCount; i++)
        {
          if (places[i].area_id === prevAreaId) {
            places[i].hiddenAreaflg = true;
          } else {
            places[i].hiddenAreaflg = false;
          }
          prevAreaId = places[i].area_id;
        }
        setPosts(res.data.places)
      })
  }, [])
  const getCardContent = getObj => {
    const bodyCardContent = {...getObj};
    return (
      <BodyCard {...bodyCardContent} />
    );
  };

  return (
    <main>
      <link rel="stylesheet" href="/css/style.css" />
      <section>
        <div class="bl_sectionTitle">
          <div class="bl_sectionTitle_left">
            <div class="el_sectionTitle_logo">
              <img src="/img/point_logo.png" alt="" />
            </div>
            <div class="el_sectionTitle_name">
              <h2>留萌周辺{placeCount}箇所の状況</h2>
            </div>
          </div>
          <div class="el_map_btn">
            <button>
                <Link to={`/map`}>
                    <img src="/img/maoBtn.png" alt="" />
                </Link>
            </button>
          </div>
        </div>
        <div class="section_grid">
          <div class="bl_gridInner">
            {post.map(contentObj => getCardContent(contentObj))}
          </div>
        </div>
      </section>
    </main>
  )
}

export default Content;
